<div class="filter-section" [formGroup]="formValue">
    <div class="amenties-header">
        <label>{{name | langtranslate}}</label>

    </div>

    <mat-spinner class="am-loader" *ngIf="showLoader"></mat-spinner>
    <!-- <p *ngIf="!showLoader && !streetNameData?.length">No Records Found</p> -->

    <ng-container formArrayName='street_name' *ngIf="streetNameData.length>0">
        <div class="filter-amenties" *ngFor="let amenties of typeForms.controls; let i=index" [formGroupName]="i">
            <div class="filter-control">
                <mat-select class="form-control" placeholder="{{'reports.searchForStreetName'|translate}}"
                    (closed)="closeSelection(i)" formControlName='name' [panelClass]="'custom-amenties-panel custom-height'">
                    <mat-select-trigger>
                        {{typeForms.controls[i].value?.name.street_name | langtranslate}}
                    </mat-select-trigger>
                    <div class="search-input">
                        <mat-icon>search</mat-icon>
                        <input matInput [(ngModel)]="filterValue[i]" (input)="filterOptions(i)"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="{{'reports.searchForStreetName'|translate}}"
                            (keydown.space)="$event.stopPropagation()" class="search-filter" />
                    </div>

                    <mat-option class="filter-amentiesD" *ngFor="let option of dataList[i]"
                        [disabled]="checkSelectedValue(option , i)" [value]="option">

                        <div class="filter-option">
                            <span>{{option.street_name | langtranslate}}</span>
                            <!-- <div class="filter-list">
                                <span [matTooltip]="option.neigh_name">{{option.neigh_name}} {{option.block_name &&
                                    option.neigh_name ? '>' : ''}} {{option.block_name}}</span>
                                <span [matTooltip]="option.property_sub_cat">{{option.property_sub_cat}}</span>
                            </div> -->
                        </div>
                    </mat-option>

                    <ng-container *ngIf="dataList[i]?.length === 0">
                        <div class="filter-option noResultFound">
                            <span>{{'reports.no-result-found'|translate}}</span>

                        </div>
                    </ng-container>
                </mat-select>
            </div>
            <div class="filter-controlRange">

                <mat-select class="form-control" placeholder="select" formControlName='distance'
                    [panelClass]="'custom-distance-panel custom-height'">
                    <mat-option *ngFor="let radius of radiusList" [value]="radius" class="filter-rangeOption">
                        {{radius.distance == 'On the street' ? (radius.distance | translate): radius.distance}} <ng-container *ngIf="radius.value != '100'">{{'reports.km'|translate}}</ng-container> </mat-option>
                </mat-select>

            </div>
            <button class="plus-icon" (click)='deleteRow(i)'><mat-icon>close</mat-icon></button>

        </div>
    </ng-container>
    <ng-container *ngIf="streetNameData.length>0">
        <button class="addAmenties"
            [disabled]="typeForms.length >= 3 || !typeForms.controls[typeForms.length - 1].value.name"
            (click)="addStreetName()">
            <span>{{'reports.addStreet'|translate}}</span>
            <mat-icon>add</mat-icon>
        </button>
    </ng-container>
</div>
